export default "__VITE_PUBLIC_ASSET__3b80f862__"